<template>
  <div class="messageCenter">
    <div class="body">
      <div class="top">
        <div class="form">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAddFolder(0)">添加顶级目录</el-button>
          <div class="right">
            <el-select v-model="folderTemplateTypeId" size="small" placeholder="项目类型" @change="handlefolderTemplateTypeChanged">
              <el-option v-for="item in folderTemplateTypeList" :key="item.dicId" :label="item.cnName"
                :value="item.dicId" />
            </el-select>
            <el-input v-model="searchName" size="small" placeholder="请输入资源名称" clearable>
              <i v-if="!searchName" slot="suffix" class="el-icon-search el-input__icon" />
            </el-input>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table key="isRead" ref="folderTable" v-loading="loading" element-loading-text="拼命加载中" row-key="folderId"
          highlight-current-row :indent="16" :tree-props="{ children: 'childrenList', hasChildren: 'hasChildren_' }"
          :data="allModule" height="100%" border :row-class-name="addclass" :expand-row-keys="expandRow" :default-expand-all="true"
          @selection-change="handleSelectionChange">
          <template slot="empty">
            <img :src="zanwu" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
          </template>
          <el-table-column label="" type="selection" width="50" align="center"></el-table-column>
          <el-table-column class-name="table-module-name" label="资源名称" prop="folderName">
            <template #default="{ row }">
              <el-link type="primary" @click="handleRename(row)">
                <i class="el-icon-folder" />
                <span :title="row.folderName">{{ row.folderName }}</span>
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="内部ID" prop="folderId" align="center" />
          <el-table-column label="归档目录" prop="archiveFolderId" align="center" width="150px" />
          <el-table-column label="归档资料类型" prop="archiveFileKind" align="center" width="150px" title="只适用于主动归档区">
            <template #default="{ row }">
              <span v-if="!row.archiveFileKind">-</span>
              <span v-if="row.archiveFileKind === 1">技术资料</span>
              <span v-if="row.archiveFileKind === 2">图纸</span>
            </template>
          </el-table-column>
          <el-table-column label="标签" prop="sysTag" align="center" width="100px" />
          <el-table-column label="限定项目" prop="restrictedPrjSubTypeName" align="center" width="100px" />
          <el-table-column label="类型" prop="folderType" align="center" width="60px" />
          <el-table-column label="排序" type="type" prop="dataOrder" align="center" width="60px" />
          <el-table-column label="操作" width="400px" align="center">
            <template #default="{ row }">
              <div class="buttons">
                <el-button type="text" icon="el-icon-top" title="上移" @click="moveUp(row)"></el-button>
                <el-button type="text" icon="el-icon-bottom" title="下移" @click="moveDown(row)"></el-button>
                <el-button type="text" icon="el-icon-top-left" title="升级(成为父节点的兄弟节点)" @click="upgradeLevel(row)">
                </el-button>
                <el-button type="text" icon="el-icon-bottom-right" title="降级(成为兄弟节点的子节点)" @click="downGradeLevel(row)">
                </el-button>
                <el-button type="text" icon="el-icon-edit" title="重命名" @click="handleRename(row)"></el-button>
                <el-button type="text" icon="el-icon-delete" title="删除" @click="deleteFolder(row)"></el-button>
                <el-button type="text" icon="el-icon-plus" title="添加子目录" @click="handleAddFolder(0, row)">
                </el-button>
                <el-button type="text" icon="el-icon-collection" title="设置归档目录" @click="handleSetArchiveFolder(row)">
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <addDlg ref="addDlg" @ok="queryTree"></addDlg>
    <renameDlg ref="renameDlg" @ok="queryTree"></renameDlg>
    <folderSelectDlg ref="folderSelectDlg" @ok="handleArchiveFolderSelected" />
  </div>
</template>

<script>
import folderTemplateService from "@/CommonDP/service/admin/folderTemplate-service";
import addDlg from "./addDlg";
import renameDlg from "./renameDlg";
import folderSelectDlg from "./folderSelectDlg";
import { STATIC } from "@/CommonDP/utils";
import dicService from "@/CommonDP/service/dic-service";

const newModuleForm = ({
  pid,
  location, // 请求地址
  sortNum, // 序号
  permissionKey, // 权限标识
  isUse, // 启用禁用
  moduleUrl,
  resourceType, // 菜单按钮
  permissionName, // 名称
  remark, // 备注
  isDelete,
  permissionId,
  iconPath, // 图标
  folderTemplateTypeId
} = {}) => {
  return {
    pid: pid || "",
    location: location || "",
    iconPath: iconPath || "",
    sortNum: sortNum || 0,
    remark: remark || "",
    permissionKey: permissionKey || "",
    isUse: isUse || "0",
    isDelete: isDelete || 0,
    moduleUrl: moduleUrl || "",
    resourceType: resourceType || 0,
    permissionName: permissionName || "",
    permissionId,
    folderTemplateTypeId
  };
};
export default {
  name: "FolderTemplate",
  components: { addDlg, renameDlg, folderSelectDlg },
  data() {
    return {
      zanwu: STATIC + "/images/暂无数据.png",
      tableData: [],
      isRead: 0,
      loading: false,
      allModuleProp: {
        visible: false,
        editVisible: false,
        rules: {
          pid: [{ required: true, message: "请选择父级名称", trigger: "change" }],
          permissionName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          resourceType: [{ required: true, message: "请选择类型", trigger: "change" }],
          moduleUrl: [{ required: true, message: "请输入外链地址", trigger: "blur" }]
        },
        editType: 0 // 0新建 1查看 2编辑
      },
      iconCheckDialog: false,
      moduleForm: {},
      selectPidProp: {
        emitPath: false,
        checkStrictly: true,
        children: "childrenList",
        value: "permissionId",
        label: "permissionName"
      },
      searchName: "",
      expandRow: [],
      currentFolder: null,
      selectedFolders: [],
      folderTemplateTypeList: [],
      folderTemplateTypeId: "",
      prjSubType: "",
      filterText: ""
    };
  },
  computed: {
    // 模块提交的数据
    addModuleForm() {
      const { moduleForm } = this;
      return { systemUse: 0, ...moduleForm };
    },

    allModule() {
      const { searchName, tableData } = this;
      const searchValue = searchName;
      if (searchValue) {
        const handleTreeData = this.handleTreeData(tableData, searchValue);
        this.setExpandRow(handleTreeData);
        return handleTreeData;
      }
      return tableData;
    }
  },
  mounted() {
    this.getModuleList();
  },
  methods: {
    // 所有的树
    async getModuleList() {
      const dictRes = await dicService.getDicList("folderTemplateType");
      this.folderTemplateTypeList = dictRes.data || [];
      if (this.folderTemplateTypeList.length) {
        this.folderTemplateTypeId = this.folderTemplateTypeList[0].dicId;
      }
      await this.queryTree();
    },
    async queryTree() {
      const { data } = await folderTemplateService.queryFolderTemplateTree(this.folderTemplateTypeId);
      this.loading = false;
      this.tableData = data;
      this.filterText = "";
      this.searchName = "";
    },
    async filterByPrjSubType() {
      const { data } = await folderTemplateService.queryFilteredTemplateTree(this.prjSubType);
      this.loading = false;
      this.tableData = data;
      this.filterText = "已筛选";
    },
    async handlefolderTemplateTypeChanged() {
      await this.$nextTick();
      await this.queryTree();
    },
    //  树形表格过滤
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return [];
      }
      const array = [];
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false;
        for (const pro in treeData[i]) {
          if (pro === "folderName") {
            if (typeof treeData[i][pro] === "string") {
              match |= treeData[i][pro].includes(searchValue);
              if (match) break;
            }
          }
        }
        if (this.handleTreeData(treeData[i].childrenList, searchValue).length > 0 || match) {
          array.push({
            ...treeData[i],
            childrenList: this.handleTreeData(treeData[i].childrenList, searchValue)
          });
        }
      }
      return array;
    },
    // 将过滤好的树形数据展开
    setExpandRow(handleTreeData) {
      if (handleTreeData.length) {
        for (const i of handleTreeData) {
          this.expandRow.push(i.permissionId);
          if (i.childrenList.length) {
            this.setExpandRow(i.childrenList);
          }
        }
      }
    },
    // 查看模块
    handleAddFolder(type = 0, moduleForm = {}) {
      if (!moduleForm.folderId) {
        moduleForm.folderId = "0";
        moduleForm.folderName = "顶级";
        moduleForm.folderTemplateTypeId = this.folderTemplateTypeId;
      }
      this.moduleForm = newModuleForm(moduleForm);
      this.moduleForm.folderTemplateTypeId = this.folderTemplateTypeId;
      this.$refs.addDlg.showAddDlg(moduleForm);
    },
    handleRename(row) {
      this.$refs.renameDlg.showDlg(row);
    },
    checkIcon() {
      this.iconCheckDialog = true;
    },
    setIcon(data) {
      this.iconCheckDialog = false;
      this.moduleForm.iconPath = data.text;
    },
    // 编辑修改
    async openEditModule(type = 0) {
      this.allModuleProp.editVisible = true;
      this.allModuleProp.editType = type;
      await this.$nextTick();
    },
    async deleteFolder(row) {
      await this.$confirm(`确定删除${row.folderName}目录及它的所有子目录吗? 注意：此操作不可恢复`, "警告", { type: "warning" });
      await folderTemplateService.deleteFolder(row.folderId);
      this.$success("删除模块成功");
      this.queryTree();
    },
    closeEditModule() {
      this.allModuleProp.editVisible = false;
    },
    addclass({ row, columnIndex }) {
      if (row.isUse == 1) {
        return "warm-row";
      }
    },
    async moveUp(row) {
      const res = await folderTemplateService.moveUp(row.folderId);
      if (res.data) {
        this.queryTree();
        this.$success("操作成功");
      }
    },
    async moveDown(row) {
      const res = await folderTemplateService.moveDown(row.folderId);
      if (res.data) {
        this.queryTree();
        this.$success("操作成功");
      }
    },
    async upgradeLevel(row) {
      const res = await folderTemplateService.upgradeLevel(row.folderId);
      if (res.data) {
        this.queryTree();
        this.$success("操作成功");
      }
    },
    async downGradeLevel(row) {
      const res = await folderTemplateService.downGradeLevel(row.folderId);
      if (res.data) {
        this.queryTree();
        this.$success("操作成功");
      }
    },
    async handleSetArchiveFolder(row) {
      this.currentFolder = row;
      this.$refs.folderSelectDlg.showDlg(row.archiveFolderId, "设置归档目录");
    },

    async handleArchiveFolderSelected(archiveFolderId) {
      await folderTemplateService.bindToArchiveFolder(this.currentFolder.folderId, archiveFolderId);
      this.currentFolder.archiveFolderId = archiveFolderId;
      this.$success("设置成功");
    },

    async handleSelectionChange(list) {
      this.selectedFolders = list;
    }
  }
};
</script>
<style lang="scss">
.form {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
.messageCenter {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;

  .tabs {
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;

    /deep/.el-badge__content {
      z-index: 1;
    }

    /deep/.el-radio-button__inner {
      padding: 10px 30px;
    }

    .role-auth-title {
      display: flex;
      padding: 10px 0 10px 20px;

      li {
        line-height: 36px;
        margin-right: 30px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
      }

      .active {
        border-bottom: 2px solid var(--theme-color);
        box-sizing: border-box;
        color: var(--theme-color);
      }
    }
  }

  .body {
    height: 100%;
    background-color: #fff;
    padding-bottom: 10px;
    position: relative;

    .top {
      padding: var(--middle-space) var(--big-space);
      position: relative;

      .right {
        position: absolute;
        right: var(--big-space);
        top: var(--middle-space);

        .el-input {
          width: 200px;
          margin-left: 10px;
        }
      }
    }

    .table {
      position: absolute;
      padding: 0 var(--big-space);
      left: 0;
      right: 0;
      bottom: var(--big-space);
      top: calc(32px + var(--middle-space) * 2);
    }
  }

  .width-220 {
    width: 100%;
  }

  .el-table>>>.warm-row {
    color: #ccc;
  }

  .buttons .el-button {
    padding: 1px 1px !important;
  }
  ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
    td:nth-of-type(2){
      padding-left: 22px;
    }
  }
}
::v-deep .cell {
  font-size: 14px;
  span{
    font-size: 14px;
  }
}
</style>
